import { Icon } from '@teamsnap/snap-ui';
import {
  LoadingType,
  useFinancials,
  useFinancialsActions,
} from 'hooks/financials';
import { isEqual } from 'lodash';
import * as React from 'react';
import InsightToggleTile from '../insights-toggle-tile';

export default function Summary() {
  const {
    loading,
    outstandingFilters: filters,
    outstandingSummary: summaryData,
  } = useFinancials();
  const { updateOutstandingFilter } = useFinancialsActions();

  if (loading[LoadingType.GetOutstandingReports] || summaryData === null) {
    return (
      <div
        data-testid="outstanding-summary-loading"
        className="sui-h-[129px] sui-max-w-[592px] sui-mb-2 sui-bg-neutral-background-weak sui-rounded"
      />
    );
  }
  return (
    <section
      data-testid="outstanding-summary-section"
      className="sui-bg-neutral-background-weak sui-rounded sui-px-4 sui-py-2 sui-w-fit sui-mb-2"
    >
      <div className="sui-flex sui-gap-4 sui-mb-2">
        <InsightToggleTile
          id="upcoming-payments-insight-toggle"
          label="Overdue Invoices"
          value={String(summaryData.overdueInvoices)}
          onToggle={
            summaryData.overdueInvoices > 0 &&
            (() => {
              updateOutstandingFilter(
                'status',
                isEqual(filters.status, ['Past Due']) ? [] : ['Past Due']
              );
              updateOutstandingFilter(
                'sourceType',
                isEqual(filters.sourceType, ['invoice']) ? [] : ['invoice']
              );
            })
          }
          selected={isEqual(filters.status, ['Past Due', 'invoice'])}
        />
        <InsightToggleTile
          label="Unpaid Registration"
          value={String(summaryData.unpaidRegistration)}
          onToggle={
            summaryData.unpaidRegistration > 0 &&
            (() => {
              updateOutstandingFilter(
                'status',
                isEqual(filters.status, ['Past Due', 'Pending Cash Payment'])
                  ? []
                  : ['Past Due', 'Pending Cash Payment']
              );
              updateOutstandingFilter(
                'sourceType',
                isEqual(filters.sourceType, ['registration'])
                  ? []
                  : ['registration']
              );
            })
          }
          selected={isEqual(filters.status, [
            'Past Due',
            'Pending Cash Payment',
          ])}
        />
        <InsightToggleTile
          label="Scheduled Payments"
          value={String(summaryData.scheduled)}
          onToggle={
            summaryData.scheduled > 0 &&
            (() =>
              updateOutstandingFilter(
                'status',
                isEqual(filters.status, ['Scheduled']) ? [] : ['Scheduled']
              ))
          }
          selected={isEqual(filters.status, ['Scheduled'])}
        />
      </div>
      <p className="sui-flex sui-items-center sui-gap-[4px]">
        <Icon name="info" size="s" className="sui-text-neutral-icon-medium" />
        This information is affected by the Date filter.
      </p>
    </section>
  );
}
